import React, { useCallback, useState } from 'react';
import styles from './menu.module.scss';
import cx from 'classnames';
import Hint from '../Hint/Hint';
import { AnimationWrapper } from '../AnimationWrapper/AnimationWrapper';
import useAccessibleClick from '../../../common/hooks/useAccessibleClick';

const MenuItem = ({ children, onClick, disabled, onHover = '', simple, messageClassName, className, ...props }) => {
  const [isHover, setIsHover] = useState(false);

  const handleClick = useCallback(
    e => {
      if (!disabled) {
        e.stopPropagation();
        onClick(e);
      }
    },
    [disabled, onClick]
  );

  const itemRef = useAccessibleClick(handleClick);

  const handleMouseOver = () => {
    disabled && onHover && setIsHover(true);
  };

  const handleMouseLeave = () => {
    disabled && onHover && setIsHover(false);
  };

  return (
    <li
      ref={itemRef}
      className={cx({ [styles.simpleMenuItem]: simple, [styles.menuItem]: !simple }, className)}
      onClick={handleClick}
      onMouseOver={handleMouseOver}
      onMouseLeave={handleMouseLeave}
      tabIndex={props.tabIndex !== undefined ? props.tabIndex : 0}
      aria-disabled={disabled}
      role="menuitem"
    >
      <div className={cx({ [styles.disabled]: disabled })}>
        {children}
      </div>
      {onHover && (
        <AnimationWrapper show={isHover} options={{ duration: 100 }}>
          <Hint className={messageClassName} text={onHover} />
        </AnimationWrapper>
      )}
    </li>
  );
};

export default MenuItem;
